class ShowroomSwiper {
  constructor(el, opt) {
    this.el = el;
    if ($("." + this.el).length > 0) {
      this.event();
    }
  }
  event() {
    const swiper = new Swiper('.' + this.el, {
      speed: 500,
      loop: true,
      slidesPerView: 1,
      effect: 'fade',
      pagination: {
        el: '.swiper-pagination',
        clickable: true,  // if you want the dots to be clickable
      },
      autoplay: {
        delay: 3000,   // 3 seconds delay between slides
        disableOnInteraction: false,  // Continue autoplay even after user interaction
      },
    })
  }
}
